// extracted by mini-css-extract-plugin
export var buttonContainer = "_70-1";
export var fontSizeSelect = "_70-3";
export var formatSelect = "_70-2";
export var formats = "_70-4";
export var hidden = "_70-5";
export var icon = "_70-6";
export var select = "_70-0";